import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component( {
    templateUrl: './his-access-disabled-page.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
} )
export class HisAccessDisabledPageComponent {

}
